export * from './zeit-entfernt.interface';
